import Type2 from "./packingItemType2";

export default Type2;
